/* MRF · крок вибору матеріалу. Спільний для бандла з каталогу і для квіза.
   Малює власний оверлей у document.body — свідомо ПОЗА React: 25.08 доклеювання
   чужих вузлів у DC-івський DOM поклало /cart помилкою removeChild.
   Дані про варіанти беремо з window.MRF_LIVE, який layout уже віддає з Liquid. */
(function () {
  var KIT = /tool kit|full set|full kit|\blite\b|base kit|wrenches/i;   /* комплектність у бандлах не пропонуємо */
  var GIFT = /gift/i;                                                   /* $0-варіанти — подарунки, не товар */
  var FREE_SHIP = 150;                   /* тариф «Free tracked airmail ($150+)» (до 27.09 «Big order»): рахується ПІСЛЯ знижки */
  var ORANGE = '#FF6B2C', INK = '#ECEDEE', MUTE = '#9BA1A8', LINE = '#23272D', PANEL = '#101216';
  var MONO = "'IBM Plex Mono', monospace", SANS = "'Space Grotesk', sans-serif";

  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, ''); }

  function variantsFor(handle) {
    var L = (window.MRF_LIVE || {})[handle];
    if (!L || !L.vars) return [];
    return L.vars.filter(function (v) {
      return v.av && v.p > 0 && !KIT.test(v.t) && !GIFT.test(v.t);
    }).sort(function (a, b) { return a.p - b.p; });
  }

  /* Матеріал — єдине, що справді змінює ціну по всіх картах; решта назви це колір/фініш. */
  function matOf(v) { return /titan/i.test(v.t) ? 'Titanium' : 'Steel'; }

  /* «Steel 440c Black» -> «Black», «440c Silver Steel» -> «Silver», «Titanium» -> «Natural» */
  function finishOf(v) {
    var t = shortLabel(v.t)
      .replace(/\btitanium\b|\btitan\b|\bsteel\b|\b440c\b|\b420\b|\bstainless\b|\bcerakote\b|\bpvd\b/gi, ' ')
      .replace(/\s+/g, ' ').trim();
    if (!t) t = 'Natural';
    return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
  }

  /* «Steel 440c / Base» -> «Steel 440c», «440c Silver Steel / Standard — card + arrow» -> «440c Silver Steel» */
  function shortLabel(t) {
    var s = String(t).replace(/\s*\/\s*(base|standard)\b.*$/i, '').trim();
    return s || String(t);
  }

  /* Підпис складу набору: «id:кількість» через кому, відсортовано. Такий самий рахує сторінка кошика. */
  function setSignature(items) {
    return items.map(function (i) { return i.id + ':' + i.quantity; }).sort().join(',');
  }

  function el(tag, style, text) {
    var n = document.createElement(tag);
    if (style) n.style.cssText = style;
    if (text != null) n.textContent = text;
    return n;
  }

  function open(cfg) {
    var slots = (cfg.slots || []).map(function (sl) {
      return { def: sl, vars: variantsFor(sl.handle), sel: null };
    });
    slots.forEach(function (s) {
      if (!s.vars.length) return;
      /* квіз уже спитав матеріал — не питаємо вдруге, а ставимо його відповідь передвибором */
      var m = null;
      if (cfg.prefer === 'titanium') m = s.vars.filter(function (v) { return /titan/i.test(v.t); })[0];
      else if (cfg.prefer === 'steel') m = s.vars.filter(function (v) { return !/titan/i.test(v.t); })[0];
      s.sel = m || s.vars[0];
    });
    var soldOut = slots.some(function (s) { return !s.vars.length; });

    /* Слоти, у яких реально є вибір матеріалу — тільки з них будуються набори.
       Гаманець чи Bushcrafter (один матеріал) просто лишаються зі своїм варіантом. */
    var dual = slots.filter(function (s) {
      var m = {};
      s.vars.forEach(function (v) { m[matOf(v)] = 1; });
      return m.Steel && m.Titanium;
    });
    /* Один тап замість трьох: вибір понижає конверсію (Андрій 25.08). Поштучний режим лишається за посиланням. */
    var mode = dual.length >= 2 ? 'preset' : 'manual';

    function variantIn(slot, mat) {
      var keep = slot.sel ? finishOf(slot.sel) : null;
      var inMat = slot.vars.filter(function (v) { return matOf(v) === mat; });
      if (!inMat.length) return slot.sel;
      return inMat.filter(function (v) { return finishOf(v) === keep; })[0] || inMat[0];
    }
    /* 'steel' — усе сталь, 'ti' — усе титан, 'mix' — перша карта сталь, друга титан (приклад Андрія:
       Universal сталь + Professional титан): тверде лезо там, де ріже, легкий метал там, де возиться. */
    function presetPick(kind, slot, idx) {
      if (kind === 'steel') return variantIn(slot, 'Steel');
      if (kind === 'ti') return variantIn(slot, 'Titanium');
      return variantIn(slot, idx % 2 === 0 ? 'Steel' : 'Titanium');
    }
    function presetSum(kind) {
      var n = -1, sum = 0;
      slots.forEach(function (sl) {
        var isDual = dual.indexOf(sl) >= 0;
        if (isDual) n++;
        var v = isDual ? presetPick(kind, sl, n) : sl.sel;
        if (v) sum += v.p;
      });
      return sum;
    }
    function applyPreset(kind) {
      var n = -1;
      slots.forEach(function (sl) {
        var isDual = dual.indexOf(sl) >= 0;
        if (!isDual) return;
        n++;
        sl.sel = presetPick(kind, sl, n);
      });
      chosenPreset = kind;
    }
    var chosenPreset = null;
    /* відповідь квіза про матеріал важить і тут: питали — не питаємо вдруге */
    if (mode === 'preset') applyPreset(cfg.prefer === 'titanium' ? 'ti' : cfg.prefer === 'steel' ? 'steel' : 'mix');

    var wrap = el('div', 'position: fixed; inset: 0; z-index: 2000002; overflow: auto; display: flex;'
      + ' align-items: flex-start; justify-content: center; padding: 20px 14px 40px;'
      + ' background: rgba(4,5,6,0.78); -webkit-backdrop-filter: blur(5px); backdrop-filter: blur(5px);');
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');

    var panel = el('div', 'width: 100%; max-width: 560px; background: ' + PANEL + '; border: 1px solid ' + LINE
      + '; border-radius: 16px; overflow: hidden; font-family: ' + SANS + '; color: ' + INK + ';');
    wrap.appendChild(panel);

    var head = el('div', 'display: flex; align-items: center; justify-content: space-between; gap: 12px;'
      + ' padding: 13px 16px; border-bottom: 1px solid #1D2025;');
    head.appendChild(el('span', 'font-family: ' + MONO + '; font-size: 10.5px; letter-spacing: 0.16em; color: ' + ORANGE + ';',
      cfg.badge || 'PICK THE MATERIAL'));
    var x = el('button', 'width: 28px; height: 28px; border-radius: 50%; border: 1px solid ' + LINE
      + '; background: #16191E; color: ' + MUTE + '; font-size: 13px; cursor: pointer; font-family: ' + SANS + ';', '\u2715');
    x.setAttribute('aria-label', 'Close');
    head.appendChild(x);
    panel.appendChild(head);

    var body = el('div', 'padding: 15px 16px 18px;');
    panel.appendChild(body);

    var err = el('div', 'display: none; margin-top: 10px; font-size: 13px; color: #FF8A65;');

    function close() {
      try { document.removeEventListener('keydown', onKey); } catch (e) {}
      if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    x.addEventListener('click', close);
    wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
    document.addEventListener('keydown', onKey);

    function totals() {
      var sum = 0;
      slots.forEach(function (s) { if (s.sel) sum += s.sel.p; });
      return discountOf(sum);
    }

    function render() {
      body.innerHTML = '';
      body.appendChild(el('div', 'font-size: 18px; font-weight: 700; line-height: 1.25;', cfg.title || ''));
      if (cfg.who) body.appendChild(el('div', 'font-family: ' + MONO + '; font-size: 10.5px; letter-spacing: 0.14em;'
        + ' color: ' + MUTE + '; margin-top: 4px;', cfg.who));

      if (soldOut) {
        body.appendChild(el('div', 'margin-top: 16px; font-size: 14.5px; line-height: 1.5; color: ' + MUTE + ';',
          'This set is sold out right now. Pick another one \u2014 the rest of the bundles are in stock.'));
        return;
      }

      function line(text, note, sum, on, onClick, tag) {
        var t = discountOf(sum);
        var b = el('button', 'display: block; width: 100%; text-align: left; margin-top: 8px; padding: 12px 14px;'
          + ' border-radius: 12px; cursor: pointer; font-family: ' + SANS + ';'
          + ' border: 1px solid ' + (on ? ORANGE : LINE) + '; background: ' + (on ? 'rgba(255,107,44,0.10)' : '#16191E') + ';');
        var top = el('div', 'display: flex; align-items: baseline; justify-content: space-between; gap: 10px;');
        var left = el('span', 'display: inline-flex; align-items: baseline; gap: 8px; color: ' + INK
          + '; font-size: 14.5px; font-weight: ' + (on ? '700' : '600') + ';');
        left.appendChild(el('span', null, text));
        if (tag) left.appendChild(el('span', 'font-family: ' + MONO + '; font-size: 9.5px; letter-spacing: 0.1em;'
          + ' color: ' + ORANGE + '; border: 1px solid ' + ORANGE + '; border-radius: 4px; padding: 1px 5px;', tag));
        top.appendChild(left);
        var right = el('span', 'font-family: ' + MONO + '; font-size: 13px; white-space: nowrap; color: ' + INK + ';');
        if (t.off > 0) right.appendChild(el('s', 'color: #9BA1A8; margin-right: 7px;', money(t.sum)));
        right.appendChild(el('span', 'font-weight: 600;', money(t.now)));
        top.appendChild(right);
        b.appendChild(top);
        if (note) b.appendChild(el('div', 'margin-top: 3px; font-size: 12.5px; color: ' + MUTE + ';', note));
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.addEventListener('click', onClick);
        return b;
      }

      function chip(text, price, on, onClick) {
        var b = el('button', 'display: inline-flex; align-items: baseline; gap: 7px; padding: 8px 13px;'
          + ' border-radius: 10px; cursor: pointer; font-family: ' + SANS + '; font-size: 13.5px;'
          + ' border: 1px solid ' + (on ? ORANGE : LINE) + '; background: ' + (on ? 'rgba(255,107,44,0.12)' : '#16191E')
          + '; color: ' + (on ? INK : '#C6CBD1') + '; font-weight: ' + (on ? '600' : '400') + ';');
        b.appendChild(el('span', null, text));
        if (price != null) b.appendChild(el('span', 'font-family: ' + MONO + '; font-size: 11.5px; color: ' + (on ? ORANGE : MUTE) + ';', money(price)));
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.addEventListener('click', onClick);
        return b;
      }

      if (mode === 'preset') {
        body.appendChild(el('div', 'margin-top: 16px; font-family: ' + MONO + '; font-size: 10px;'
          + ' letter-spacing: 0.14em; color: ' + MUTE + ';', 'CHOOSE YOUR SET'));
        [['steel', 'All steel', 'Hardest edge, best price'],
         ['mix', 'Steel + titanium', 'Steel where it cuts, titanium where it rides'],
         ['ti', 'All titanium', 'Lightest, rust-proof, non-magnetic']].forEach(function (p) {
          body.appendChild(line(p[1], p[2], presetSum(p[0]), chosenPreset === p[0],
            function () { applyPreset(p[0]); render(); }, p[0] === 'mix' ? 'WE PICK' : null));
        });
        var sw = el('button', 'margin-top: 12px; background: none; border: 0; padding: 0; cursor: pointer;'
          + ' font-family: ' + SANS + '; font-size: 13px; color: ' + MUTE + '; text-decoration: underline;',
          'Choose each card separately \u2192');
        sw.addEventListener('click', function () { mode = 'manual'; render(); });
        body.appendChild(sw);
        tail();
        return;
      }

      slots.forEach(function (s, i) {
        var box = el('div', 'margin-top: ' + (i ? 14 : 16) + 'px;');
        box.appendChild(el('div', 'font-family: ' + MONO + '; font-size: 10px; letter-spacing: 0.14em; color: ' + MUTE
          + '; margin-bottom: 7px;', s.def.label.toUpperCase()));

        var mats = [];
        s.vars.forEach(function (v) { var m = matOf(v); if (mats.indexOf(m) < 0) mats.push(m); });

        if (mats.length > 1) {
          /* ряд 1 — матеріал. У квізі він приходить уже обраним, бо квіз про це питав. */
          var r1 = el('div', 'display: flex; flex-wrap: wrap; gap: 7px;');
          mats.forEach(function (m) {
            var inMat = s.vars.filter(function (v) { return matOf(v) === m; });
            var on = matOf(s.sel) === m;
            r1.appendChild(chip(m, inMat[0].p, on, function () {
              if (on) return;
              var keep = finishOf(s.sel);
              s.sel = inMat.filter(function (v) { return finishOf(v) === keep; })[0] || inMat[0];
              render();
            }));
          });
          box.appendChild(r1);

          /* ряд 2 — колір усередині обраного матеріалу; показуємо, лише коли є з чого обирати */
          var same = s.vars.filter(function (v) { return matOf(v) === matOf(s.sel); });
          if (same.length > 1) {
            var r2 = el('div', 'display: flex; flex-wrap: wrap; gap: 7px; margin-top: 7px;');
            same.forEach(function (v) {
              r2.appendChild(chip(finishOf(v), v.p, s.sel.id === v.id, function () { s.sel = v; render(); }));
            });
            box.appendChild(r2);
          }
        } else {
          /* Один матеріал. Якщо він названий у КОЖНОМУ варіанті (Bushcrafter: «440c Stainless Steel»),
             показуємо тільки колір. Інакше (гаманець «Brown + Black», Designer, Survival Kit) —
             повні назви, бо там прибирати нічого. */
          var named = s.vars.every(function (v) { return /steel|titan|440c|420/i.test(v.t); });
          var r = el('div', 'display: flex; flex-wrap: wrap; gap: 7px;');
          s.vars.forEach(function (v) {
            r.appendChild(chip(named ? finishOf(v) : shortLabel(v.t), v.p, s.sel.id === v.id,
              function () { s.sel = v; render(); }));
          });
          box.appendChild(r);
        }
        body.appendChild(box);
      });

      if (dual.length >= 2) {
        var back = el('button', 'margin-top: 14px; background: none; border: 0; padding: 0; cursor: pointer;'
          + ' font-family: ' + SANS + '; font-size: 13px; color: ' + MUTE + '; text-decoration: underline;',
          '\u2190 Back to ready sets');
        back.addEventListener('click', function () { mode = 'preset'; render(); });
        body.appendChild(back);
      }
      tail();
    }

    /* Знижку реально застосовує Shopify Function (mrf-set-app): вона знаходить рядки з
       мітками _mrf_rule/_mrf_set, перевіряє склад набору на сервері і знімає точний
       відсоток лише з цих рядків. Тут той самий розрахунок — але тільки для показу. */
    function discountOf(sum) {
      var d = cfg.discount;
      if (!d) return { sum: sum, off: 0, now: sum };
      var off = d.type === 'pct' ? Math.round(sum * d.value) / 100 : Math.min(d.value, sum);
      return { sum: sum, off: off, now: Math.max(0, sum - off) };
    }

    function tail() {
      if (cfg.gift) {
        var g = el('div', 'margin-top: 15px; display: flex; align-items: center; gap: 9px; padding: 10px 12px;'
          + ' border: 1px dashed rgba(5,206,120,0.5); border-radius: 10px; background: rgba(5,206,120,0.06);');
        g.appendChild(el('span', 'font-family: ' + MONO + '; font-size: 10px; letter-spacing: 0.12em; color: #05CE78;', 'FREE'));
        g.appendChild(el('span', 'font-size: 13.5px; color: #C6CBD1;', cfg.gift.label));
        body.appendChild(g);
      }

      var t = totals();
      var sums = el('div', 'margin-top: 16px; display: flex; align-items: baseline; gap: 10px; flex-wrap: wrap;');
      if (t.off > 0) sums.appendChild(el('s', 'font-family: ' + MONO + '; font-size: 13.5px; color: #9BA1A8;', money(t.sum)));
      sums.appendChild(el('span', 'font-size: 23px; font-weight: 700;', money(t.now)));
      if (t.off > 0) sums.appendChild(el('span', 'font-size: 13px; color: #05CE78;', 'you save ' + money(t.off)));
      body.appendChild(sums);

      var need = FREE_SHIP - t.now;
      body.appendChild(el('div', 'margin-top: 5px; font-size: 12px; line-height: 1.45; color: ' + MUTE + ';',
        need <= 0 ? 'Free worldwide shipping included.'
                  : 'Shipping is charged separately \u2014 it is free from ' + money(FREE_SHIP) + ' (' + money(need) + ' to go).'));

      var cta = el('button', 'margin-top: 14px; width: 100%; border: 0; border-radius: 12px; padding: 13px 18px;'
        + ' background: ' + ORANGE + '; color: #0B0C0E; font-family: ' + SANS + '; font-size: 15.5px; font-weight: 700; cursor: pointer;',
        cfg.ctaLabel || 'Add to cart \u2192');
      cta.addEventListener('click', function () { add(cta); });
      body.appendChild(cta);
      body.appendChild(err);
    }

    function add(btn) {
      /* Кошик більше не чистимо: знижка фіксована, від чужих товарів вона не росте,
         тож набір спокійно живе поруч із будь-чим іншим (Андрій 25.08). */
      btn.disabled = true;
      btn.style.opacity = '0.6';
      btn.textContent = 'Adding\u2026';
      err.style.display = 'none';
      err.style.color = '#FF8A65';
      /* мітки для Shopify Function: правило знижки + id групи, щоб два набори жили нарізно */
      var setId = 's' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      var rule = cfg.discount && cfg.discount.rule;
      var items = slots.map(function (s, i) {
        var props = {}, base = (cfg.slots[i] && cfg.slots[i].props) || {};
        for (var k in base) props[k] = base[k];
        if (rule) { props._mrf_rule = rule; props._mrf_set = setId; }
        return { id: s.sel.id, quantity: 1, properties: props };
      });
      /* 28.08: подарунок — платний варіант (безплатність дає функція mrf-set-app), тож він може бути
         розпроданий (DENY). Додаємо ОКРЕМИМ запитом: розпроданий подарунок не має валити додавання карт. */
      var gift = (cfg.gift && cfg.gift.id)
        ? { id: cfg.gift.id, quantity: 1, properties: cfg.gift.props || { _mrf_quiz: 'free_gift' } }
        : null;
      var addedItems = [];   // наряд 23.09: рядки з відповіді першого /cart/add.js — для Klaviyo "Added to Cart"
      Promise.resolve().then(function () {
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }); }).then(function (r) {
        return r.json().then(function (j) { return r.ok ? j : Promise.reject(new Error(j.description || j.message || 'Could not add to cart.')); },
                             function () { return Promise.reject(new Error('Could not add to cart.')); });
      }).then(function (j) {
        addedItems = (j && j.items) || [];
        if (!gift) return null;
        return fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [gift] })
        }).then(function (r) { if (r.ok) items.push(gift); }).catch(function () {});
      }).then(function () {
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return null; });
      }).then(function (cart) {
        // наряд 23.09 (Klaviyo Added to Cart, крок Б): лише Klaviyo, без fbq (Meta AddToCart вже шле застосунок Facebook)
        try { if (cart) { window._learnq = window._learnq || []; window._learnq.push(['track', 'Added to Cart', window.mrfCartEvent(addedItems, cart)]); } } catch (e) {}
        try { if (cfg.onAdded) cfg.onAdded({ items: items, total: totals() }); } catch (e) {}
        window.location.href = '/cart';
      }).catch(function (e) {
        btn.disabled = false; btn.style.opacity = ''; btn.textContent = cfg.ctaLabel || 'Add to cart \u2192';
        err.style.color = '#FF8A65';
        err.textContent = (e && e.message) || 'Could not add to cart.';
        err.style.display = 'block';
      });
    }

    render();
    document.body.appendChild(wrap);
    setTimeout(function () { try { x.focus(); } catch (e) {} }, 0);   /* не rAF: у невидимій вкладці не спрацює */
    return { close: close };
  }

  window.MRF_BUNDLE = { open: open, variantsFor: variantsFor };
})();
